import { SelectFields } from '@repo/toolkit/types'

import { TripBookingDispatchPlace } from '../../models/trip-booking-dispatch-places/trip-booking-dispatch-place'
import { FieldsSelector } from '../../utils'

export const enrollmentDispatchPlacesFields = [
  'id',
  'dispatched',
  'directionality',
  'type',
  'individualType',
  'tripBooking.isTakeInCharge',
  'tripBooking.mainReservationId',
  'tripBooking.travelCompany.name',
  'tripStep.departureDate',
  'tripStep.arrivalDate',
  'tripStep.departureTime',
  'tripStep.arrivalTime',
  'tripStep.departureTimeZone',
  'tripStep.arrivalTimeZone',
  'tripStep.timeBeforeDepartureForParents',
  'tripStep.timeBeforeArrivalForParents',
  'tripStep.transportMeanNumber',
  'tripStep.carNumber',
  'tripStep.id',
  'tripStep.directionality'
] as const satisfies FieldsSelector<TripBookingDispatchPlace>

export type EnrollmentDispatchPlacesType = SelectFields<
  TripBookingDispatchPlace,
  typeof enrollmentDispatchPlacesFields
>
